<template>
  <Navbar :center-text="$t('LoginView.login')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>
  <div class="container container-login mt-1 d-flex justify-content-center align-items-center">
    <form @submit.prevent="handleLogin"
          class="form-horizontal w-100">
      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-12 mb-5">
          <div class="alert alert-info">
            <a href="http://canalls.uni-hohenheim.de/backend/index.php/documents/99faeea6-8049-4573-82b5-f584ae5fc3bf">{{$t('LoginView.accountTutorial')}}</a>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-12 mt-1 mb-4">
          <label for="email"
                 class="form-label">
            {{ $t('email') }}
          </label>
          <input
              v-model="email"
              type="text"
              class="form-control rounded-pill"
              id="email"
              :placeholder="$t('enterEmail')"
              required/>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-12 mb-4">
          <label for="password"
                 class="form-label">
            {{ $t('password') }}
          </label>
          <input
              v-model="password"
              type="password"
              class="form-control rounded-pill"
              id="password"
              :placeholder="$t('enterPassword')"
              required/>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-12 mb-4">
          <input type="checkbox"
                 id="rememberMe"/>
          <label class="form-label m-2"
                 for="rememberMe">
            {{ $t('LoginView.rememberMe') }}
          </label>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-12 mb-4">
          <button type="submit"
                  class="btn btn-success w-100 rounded-pill mb-2">
            <i class="bi bi-person-fill"></i>
            {{ $t('LoginView.login') }}
          </button>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-12 mb-4">
          <button class="btn btn-secondary w-100 rounded-pill"
                  @click="$router.push('/register')">
            <i class="bi bi-person-plus-fill"></i>
            {{ $t('RegistrationView.register') }}
          </button>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-12 mb-4">
          <a class="link-secondary link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover"
             @click="$router.push('/reset')">
            {{ $t('LoginView.forgotPassword') }}
          </a>
        </div>
      </div>
    </form>
  </div>
  <Footerbar></Footerbar>
</template>

<script>
import axios from "axios";
import Navbar from "../../components/Navbar.vue";
import Footerbar from "../../components/Footerbar.vue";
import {sharedState} from "@/store";
import {postLogin} from "@/utils";

axios.defaults.withCredentials = true;

export default {
  data() {
    return {
      email: "",
      password: "",
      message: "",
      messageType: "",
      sharedState
    };
  },
  components: {
    Navbar,
    Footerbar,
  },
  methods: {
    async handleLogin() {
      let response = await postLogin(this.email, this.password);
      if (response.status === 200) {
        localStorage.setItem('access_token', response.data.access_token);
        const token = JSON.parse(atob(response.data.access_token.split('.')[1]));

        this.sharedState.user_id = token['id'];
        this.sharedState.user_firstname = token['firstname'];
        this.sharedState.user_isAdmin = token['isAdmin'];
        this.sharedState.user_expiration = token['exp'];

        this.$router.push({
          name: "home",
        });
      } else {
        this.message = response.response.data.message;
        this.messageType = "danger"
      }
    },
  },
};
</script>